'use client';
import { useModalContext } from '../Modal.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function useModalBackdropTransition(transitionOverride) {
    const context = useModalContext();
    return _extends({
        duration: 200,
        timingFunction: 'ease',
        transition: 'fade'
    }, context.transitionProps, transitionOverride);
}

export { useModalBackdropTransition };
//# sourceMappingURL=useModalBackdropTransition.js.map
